import { makeStyles } from '@material-ui/core/styles'

const useOptionDropdownStyles = makeStyles(theme => ({
    root: {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        alignItems: 'flex-start !important',
        padding: '12px 16px',
        minWidth:'10rem',
        minHeight:'2.625rem !important',
        maxHeight:'5.25rem',
        '& .MuiListItemText-root': {
            margin: '0'
        },
        '& .MuiContainer-root': {
            margin: '0',
            width: '100%'
        },
        '& .MuiMenuItem-root':{
            minHeight:'none'
        },

    },
    itemSelector: {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        alignItems: 'flex-start !important',
        padding: '0.75rem 0.75rem 0.688rem 1rem !important',
        minWidth:'10rem',
        maxWidth:'20.625rem',
        minHeight:'2.625rem !important',
        maxHeight:'5.25rem',
        overflow: 'visible',
    },
    selected: {
        backgroundColor: `${theme.palette.grey[300]} !important`,
        '& .MuiMenuItem-optionText': {
            '& span': {
                fontWeight: '700'
            }
        },
    },
    disabled: {
        backgroundColor: `${theme.palette.grey[100]} !important`,
        opacity:'1 !important',
        '& .MuiMenuItem-optionText': {
            '& span': {
                fontWeight: '600',
                color: `${theme.palette.grey[500]}`
            }
        },
        '& svg': {
            color: `${theme.palette.grey[400]} !important`,
        },

    },
    multiSelect: {
        marginRight: '0.75rem',
        minWidth: '0 !important',
        '& svg': {
            color: theme.palette.primary.main,
            fontSize: '20px',
            marginTop: '-1px'
        }
    },
    optionText: {
        '& span': {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            fontWeight: '600',
            fontSize: '14px',
            lineHeight: '19px',
            color: theme.palette.grey[700]
        }
    },
    descriptionTextOneLine: {
        paddingTop: '0.25rem',
        width: '100%',
        paddingBottom:'0.062rem',
        color: theme.palette.grey[700],
        '& span': {
            fontWeight: '400',
            fontSize: '13px',
            lineHeight: '18px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        }
    },
    descriptionTextTwoLines: {
        paddingTop: '0.25rem',
        paddingBottom:'0.125rem',
        width: '100%',
        color: theme.palette.grey[700],
        '& span': {
            minHeight: '36px',
            fontWeight: '400',
            fontSize: '13px',
            lineHeight: '18px',
            display: '-webkit-box',
            '-webkit-line-clamp': 2,
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
            whiteSpace: 'normal',
            textOverflow: 'ellipsis',
        }
    },
    rightText: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: '1rem',
        width:'51px',
        color: theme.palette.grey[700],
        '& span': {
            fontWeight: '600',
            fontSize: '14px',
            lineHeight: '19px'
        }
    },
    containerText: {
        overflow: 'hidden'
    }
}), { name: 'MuiMenuItem' });

export default useOptionDropdownStyles
